"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Action() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section data-section-id="6053" id="call-to-action" className="text-foreground relative overflow-hidden py-24 px-5 dark bg-accent !h-[450px] md:py-32 md:px-12">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute left-1/2 top-[8%] -translate-x-1/2 w-[320px] h-[320px] md:w-[460px] md:h-[460px] rounded-lg blur-3xl opacity-45" style={{
      background: "var(--accent)",
      animation: "blobDrift 14s ease-in-out infinite"
    }} />

      <style>{`
        @keyframes blobDrift {
          0%, 100% { transform: translate(-50%, 0); }
          50% { transform: translate(calc(-50% + 18px), -12px); }
        }
      `}</style>

      <div ref={ref} className="relative max-w-[760px] mx-auto text-center flex flex-col items-center">
        <h2 className="font-default font-normal tracking-tight leading-[1.1] !italic text-secondary" style={{
        fontSize: "clamp(2rem, 3.8vw, 3.25rem)",
        letterSpacing: "-0.018em",
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(16px)",
        transition: "opacity 600ms cubic-bezier(0.22, 1, 0.36, 1), transform 600ms cubic-bezier(0.22, 1, 0.36, 1)"
      }}>Automate the work that slows your business down.</h2>

        <p className="mt-8 font-default font-normal text-muted-foreground max-w-[580px] mx-auto leading-relaxed !italic md:mt-10" style={{
        fontSize: "clamp(1.0625rem, 1.25vw, 1.25rem)",
        letterSpacing: "-0.005em",
        lineHeight: 1.55,
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(16px)",
        transition: "opacity 600ms cubic-bezier(0.22, 1, 0.36, 1) 80ms, transform 600ms cubic-bezier(0.22, 1, 0.36, 1) 80ms"
      }}>Reduce repetitive tasks, improve accuracy, and create practical technology solutions that make your workflows faster, clearer, and easier to manage.</p>

        <div className="mt-10 md:mt-12 flex flex-col sm:flex-row items-stretch sm:items-center justify-center gap-4 w-full sm:w-auto" style={{
        opacity: isVisible ? 1 : 0,
        transform: isVisible ? "translateY(0)" : "translateY(16px)",
        transition: "opacity 600ms cubic-bezier(0.22, 1, 0.36, 1) 160ms, transform 600ms cubic-bezier(0.22, 1, 0.36, 1) 160ms"
      }}>
          <Button asChild className="h-14 px-8 rounded-lg bg-primary text-primary-foreground font-default font-semibold text-base shadow-md hover:bg-primary/90 hover:shadow-lg transition-all duration-220 hover:scale-[1.04]" style={{
          transitionTimingFunction: "cubic-bezier(0.34, 1.56, 0.64, 1)"
        }}>
            <Link to="/GetInTouchPage">Discuss Automation Needs</Link>
          </Button>

          <Button asChild variant="outline" className="h-14 px-8 rounded-lg border-[1.5px] border-foreground bg-transparent text-foreground font-default font-medium text-base hover:bg-foreground hover:text-background transition-colors duration-200">
            <Link to="/OurServicesPage">View our services</Link>
          </Button>
        </div>
      </div>
    </section>;
}